import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M19,2H6.3c-1.5,0-2.7,1-3,2.5l-1.3,7c-0.3,1.6,0.8,3.2,2.4,3.5c0.2,0,0.4,0,0.5,0h4.6L9,16.4c-0.8,2.1,0.3,4.5,2.4,5.3c0.5,0.2,0.9,0.3,1.4,0.3c0.4,0,0.8-0.2,0.9-0.6l2.8-6.4H19c1.7,0,3-1.3,3-3V5C22,3.3,20.7,2,19,2z M20,12c0,0.6-0.4,1-1,1h-2V4h2c0.6,0,1,0.4,1,1V12z" }, null, -1)
  ])))
}
export default { render: render }